module.exports = __webpack_public_path__ + "static/media/blog7-image.197ed41d.jpg";